import React, {useContext} from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {useFormikContext} from "formik";

import RadioGroup from "components/radioGroup/RadioGroup";
import FormControlLabel from "components/radioGroup/FormControlLabel";
import SelectTitle from "components/radioGroup/SelectTitle";

import {RetailerFilter} from "utils/recommendation";

import {RecommendationFormContext} from "../../context/RecommendationFormContext";

function RetailerFilterField(props) {
    const { formFieldName, intl } = props;

    const formikContext = useFormikContext();

    const {getValueByFormFieldName} = useContext(RecommendationFormContext);

    let value = getValueByFormFieldName(formFieldName);

    return (
        <>
            <SelectTitle
                titleTranslationKey={'recommendations.form.filter.retailer.title'}
                subtitleTranslationKey={'recommendations.form.filter.select_filter'}
            />
            <RadioGroup
                selectedValueLabel={intl.formatMessage({id: `recommendations.form.filter.retailer.${value}`})}
                name={formFieldName}
                value={value}
                onChange={(event) => {
                    formikContext.setFieldValue(formFieldName, event.currentTarget.value)
                }}
            >
                {Object.values(RetailerFilter).map((filterName, index) => (
                    <FormControlLabel
                        key={index}
                        value={filterName}
                        label={intl.formatMessage({id: `recommendations.form.filter.retailer.${filterName}`})}
                    />
                ))}
            </RadioGroup>
        </>
    )
}

RetailerFilterField.propTypes = {
    formFieldName: PropTypes.string.isRequired
}

export default injectIntl(RetailerFilterField);
